<svg:circle
  [attr.fill]="fill"
  xmlns:svg=""
  [attr.r]="r"
  [attr.cx]="cy"
  [attr.cy]="cx"
  [attr.stroke-dashoffset]="strokeDashOffset"
  [attr.stroke-dasharray]="strokeDashArray"
  [attr.stroke-width]="strokeWidth"
  [style.stroke]="getStrokeColor()"
  [ngClass]="getStrokeColorClass()"
></svg:circle>
